import {
    NextSignupFlowMessage,
    NextSignupFlowMessageError,
    POST_NEXT_SIGNUP_FLOW_MESSAGE,
    POST_NEXT_SIGNUP_FLOW_MESSAGE_ERROR,
    POST_NEXT_SIGNUP_FLOW_MESSAGE_SUCCESS,
    SignupFlowMessageAction,
} from '../_types/nextSignupFlowMessage';

export const setNextSignupFlowLoading = (): SignupFlowMessageAction => {
    return {
        type: POST_NEXT_SIGNUP_FLOW_MESSAGE,
    };
};

export const setNextSignupFlowError = (err: NextSignupFlowMessageError): SignupFlowMessageAction => {
    return {
        type: POST_NEXT_SIGNUP_FLOW_MESSAGE_ERROR,
        payload: err,
    };
};

export const setNextSignupFlowSuccess = (data: NextSignupFlowMessage): SignupFlowMessageAction => {
    return {
        type: POST_NEXT_SIGNUP_FLOW_MESSAGE_SUCCESS,
        payload: data,
    };
};
